import React from 'react'
import cn from 'classnames'

import './index.scss'

const UbliqueRow = ({ children, className, direction = 'row' }) => {
  return (
    <div
      className={cn('row-stripe', className, {
        'direction-row': direction === 'row',
        'direction-column': direction === 'column'
      })}
    >
      {children}
    </div>
  )
}

export default UbliqueRow
